import { format } from 'date-fns';

type DateRange = {
    startDate: string;
    endDate?: string;
};

const DateRangeCellRenderer = (row: any, field: string) => {
    const dateRanges: DateRange[] = row[field];

    if (!Array.isArray(dateRanges) || dateRanges.length === 0) {
        return '';
    }

    const formattedDateRanges = dateRanges.map(({ startDate, endDate }) => {
        const formattedStartDate = format(new Date(startDate), 'dd/MM/yyyy');
        const formattedEndDate = endDate
            ? format(new Date(endDate), 'dd/MM/yyyy')
            : '';

        if (!endDate || formattedStartDate === formattedEndDate) {
            return formattedStartDate;
        }

        return `${formattedStartDate} to ${formattedEndDate}`;
    });

    return (
        <div>
            {formattedDateRanges.map((formattedDate, index) => (
                <div key={index}>{formattedDate}</div>
            ))}
        </div>
    );
};

export default DateRangeCellRenderer;
